import { render, staticRenderFns } from "./BriqueChartModalChartType.vue?vue&type=template&id=b87cc08e&"
import script from "./BriqueChartModalChartType.js?vue&type=script&lang=js&"
export * from "./BriqueChartModalChartType.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports